<script>
  const ItemSelected = () => import("./ItemSelected.vue");

  export default {
    name: "LocationsList",
    components: { ItemSelected },

    props: {
      locations: {
        type: Array,
        default: () => [],
      },
      onClick: {
        type: Function,
        default: null,
      },
      delLocSelected: {
        type: Function,
        required: true,
      },
      iconName: {
        type: String,
        default: "filter",
      },
      placeholder: {
        type: String,
        default: "Ciudad",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      hasLocations() {
        return Array.isArray(this.locations) && this.locations.length > 0;
      },
    },

    methods: {
      handleOpen(e) {
        if (e && e.preventDefault) e.preventDefault();
        this.$emit("open", e);
        if (typeof this.onClick === "function") this.onClick(e);
      },
      handleToggle(e) {
        this.$emit("toggle", e);
        if (!this.hasLocations) this.handleOpen(e);
      },
    },
  };
</script>

<template>
  <div class="locationsList" @click="handleToggle">
    <iconic class="locationsList__icon" :name="iconName" :height="17" :width="17" color="#252525" @click.native.stop="handleOpen" />

    <div class="locationsList__wrapper">
      <template v-if="hasLocations">
        <ItemSelected v-for="loc in locations" :key="loc._id" :item="loc" :onClose="disabled ? null : delLocSelected" />
      </template>
      <p v-else class="locationsList__placeholder">{{ placeholder }}</p>
    </div>

    <button v-if="hasLocations && !disabled" type="button" class="locationsList__xMarkIcon" @click.stop="() => delLocSelected()" aria-label="Limpiar ubicaciones" title="Limpiar">
      <iconic name="close" />
    </button>
  </div>
</template>

<style lang="scss">
  .locationsList {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    background: #f0f0f0;
    box-shadow: 0px 0.5px 2px rgba(0, 0, 0, 0.41);

    &__icon {
      flex: 0 0 auto;
      display: inline-flex;
    }

    &__wrapper {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      gap: 6px;
      overflow-x: auto;
      overflow-y: hidden;
      padding-bottom: 6px;
      margin-bottom: -6px;

      scrollbar-width: thin;
      scrollbar-color: #9ca3af #e5e7eb;
    }
    &__wrapper::-webkit-scrollbar {
      height: 2px;
    }

    &__placeholder {
      margin: 0;
      font-size: 14px;
      user-select: none;
    }

    &__xMarkIcon {
      flex: 0 0 auto;
      border: none;
      background: transparent;
      padding: 4px;
      line-height: 0;
      cursor: pointer;
      color: #4b5563;
      font-size: 10px;

      &:hover {
        color: #111827;
      }
    }
  }
</style>
